/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_JoinQueueMutationVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type MentorDash_JoinQueueMutation = {
  __typename?: 'Mutation';
  queue?: {
    __typename?: 'queueMutationType';
    enqueue?: {
      __typename?: 'QueueReviewer';
      status?: Types.ReviewerStatus | null;
      expiresAt?: any | null;
      options: Array<{
        __typename?: 'QueueOpportunityOption';
        enabled: boolean;
        opportunity: { __typename?: 'QueueOpportunity'; project: { __typename?: 'QueueProject'; projectID: string } };
      }>;
    } | null;
  } | null;
};

export const MentorDash_JoinQueueDocument = `
    mutation MentorDash_JoinQueue($projectIds: [String!]!) {
  queue {
    enqueue(projects: $projectIds) {
      status
      expiresAt
      options {
        enabled
        opportunity {
          project {
            projectID
          }
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_JoinQueue: build.mutation<MentorDash_JoinQueueMutation, MentorDash_JoinQueueMutationVariables>({
      query: (variables) => ({ document: MentorDash_JoinQueueDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
